import {NgxFilterBaseComponent} from "../../ngx-filter-base-component";
import {FilterSelectBoxOptions} from "../../../ngx-types";
import {AfterViewInit, Directive} from "@angular/core";
import {Observable} from "rxjs";

@Directive({})
export abstract class NgxSelectBoxFilter extends NgxFilterBaseComponent implements AfterViewInit {

  filterSourceChange(src) {
    // if (this.options.source)
    // this.options? this.options.source = src: '';
  }

  get selectBoxOptions(): FilterSelectBoxOptions {
    return this.filter?.options?.selectBoxOptions;
  }

  get placeholder(): string {
    return this.selectBoxOptions?.searchBoxPlaceholder;
  }

  get emptyText(): string {
    return this.selectBoxOptions?.emptyText;
  }

  get lazyLoad(): boolean {
    return this.selectBoxOptions?.lazyLoad
  }

  get displayMember(): string {
    if (!this.selectBoxOptions?.displayMember) {
      return 'name';
    }
    return this.selectBoxOptions.displayMember;
  }

  get valueMember(): string {
    if (!this.selectBoxOptions?.valueMember) {
      return 'id';
    }
    return this.selectBoxOptions.valueMember;
  }

  get searcher(): (search: string, pageNumber: number, maxResultCount: number) => Observable<any[]> {
    if (this.selectBoxOptions?.searcher) {
      return this.selectBoxOptions?.searcher as any;
    }
    return null;
  }

  get initSource(): any[] {
    if (this.selectBoxOptions?.source) {
      return this.selectBoxOptions.source;
    }
    return [];
  }

  get compareWidth(): any {
    return this.selectBoxOptions['compareWith']
  }

  get useMobileView(): boolean {
    return this.selectBoxOptions?.useMobileView
  }

  get hasSearch(): boolean {
    return this.selectBoxOptions?.hasSearch;
  }

  get mobileViewType(): 'BottomSheet' | 'FullScreen' {
    return this.selectBoxOptions?.mobileViewType;
  }

  get maximumResultForShow(): number {
    return this.selectBoxOptions?.maximumResultForShow;
  }

  get useInfiniteScroll(): boolean {
    return this.selectBoxOptions?.useInfiniteScroll;
  }

  get noMoreResultLabel(): string {
    return this.selectBoxOptions?.noMoreResultLabel;
  }

  get inFirstLoadCallSearcher(): boolean {
    return this.selectBoxOptions?.afterViewInitCallSearcher;
  }

  get inFirstLoadSearcherValue(): string {
    return this.selectBoxOptions?.inFirstLoadSearcherValue;
  }

  ngAfterViewInit(): void {
    // if (this.selectBoxOptions?.afterViewInitCallSearcher) {
    //   if (this.searcher) {
    //     this.searcher('').subscribe(z => {
    //       this.selectBoxOptions.source = z;
    //     });
    //   }
    // }
  }
}
